'use client';

import { createContext, useContext } from 'react';

import { Database } from '../supabase/database.types';

type HumanReviewer = Database['public']['Tables']['HumanReviewer']['Row'];

interface UserContextType {
  user?: any | null;
  humanReviewer?: HumanReviewer | null;
}

export const UserContext = createContext<UserContextType>({});
export const useUserContext = () => useContext(UserContext);

export default function UserContextProvider({
  user,
  humanReviewer,
  children
}: UserContextType & { children: React.ReactNode }) {
  return (
    <UserContext.Provider
      value={{
        user,
        humanReviewer
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
